export default {
    errors: {
        token_invalid: 'Недействительный токен приглашения',
        invitation_unkown_or_used: 'Приглашение уже использовано или недействительно',
    },
    buttons: {
        signup: 'Зарегистрироваться',
        continue_with_google: 'Продолжить с Google',
        continue_with_apple: 'Продолжить с Apple',
        continue_with_facebook: 'Продолжить с Facebook',
    },
    fields: {
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
        first_name: {
            label: 'Имя',
            placeholder: 'Aleksandr',
        },
        last_name: {
            label: 'Фамилия',
            placeholder: 'Karelin',
        },
        password: {
            label: 'Пароль',
            placeholder: 'Минимум 6 символов',
        },
        password_repeat: {
            label: 'Повторите пароль',
            placeholder: 'Введите пароль еще раз',
        },
    },
    passwords_not_match: 'Пароли не совпадают',
    please_register: 'Пожалуйста, войдите, чтобы продолжить!',
    no_account: 'Нет аккаунта?',
    agrement: 'Я согласен с',
    terms: 'Условиями использования',
}
